<ng-content select="wz-form-group-part-item-title"></ng-content>
<div class="item-container">
  <button
    type="button"
    tabindex="-1"
    *ngIf="hasDelete"
    (click)="onDeleteClick()"
    class="clear"
    mat-icon-button
    color="warn"
  >
    <mat-icon>clear</mat-icon>
  </button>
  <ng-content></ng-content>
</div>
